import { render, staticRenderFns } from "./AllotmentData.vue?vue&type=template&id=4a266967&scoped=true&"
import script from "./AllotmentData.vue?vue&type=script&lang=js&"
export * from "./AllotmentData.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentData.vue?vue&type=style&index=0&id=4a266967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a266967",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
